import { Dispatch, SetStateAction } from 'react';

import { Interweave } from 'interweave';

import { useHomeData } from '@liscio/common';
import { Dialog, Loading } from '@liscio/ui';

type PrivacyPolicyDialogProps = {
  open: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
};

export default function PrivacyPolicyDialog({
  open,
  setIsOpen,
}: PrivacyPolicyDialogProps) {
  const { data: homeData, isLoading } = useHomeData();

  return (
    <Dialog
      onClose={() => setIsOpen(false)}
      open={open}
      fullWidth
      maxWidth="lg"
    >
      {isLoading ? (
        <Loading />
      ) : (
        <Interweave content={homeData?.data?.privacy_content || ''} />
      )}
    </Dialog>
  );
}
